<template>
  <div class="special-main surgic-star">
    <div class="special-body">
      <!-- ================= 1. Hero ================= -->
      <section class="ss-hero">
        <div class="ss-hero-title-container">
          <p class="ss-hero-sub">3-in-1 Advanced Surgical System</p>
          <img class="ss-hero-title" :src="assets.productName" alt="Surgic Star">
        </div>
        <div class="ss-hero-product">
          <img :src="assets.hero" alt="Surgic Star">
        </div>
      </section>

      <!-- ================= 2. Dark Video Banner ================= -->
      <section class="ss-video-banner">
        <video class="ss-video-bg"
               :ref="videoList[0].ref"
               :src="videoList[0].video"
               muted
               playsinline
               loop></video>
        <div class="ss-video-mask"></div>
        <div class="ss-video-text">
          <h4>One System. Multiple Applications.</h4>
          <h4>Seamless Collaboration.</h4>
          <h4>Built on Expertise.</h4>
          <view-button @onclick="openVideoModal(videoList[0].previewVideo)"></view-button>
        </div>
        <div class="progress">
          <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
        </div>
      </section>

      <!-- ================= 3. Three Modes ================= -->
      <section class="ss-modes">
        <div class="ss-mode-list">
          <div class="ss-mode-item">
            <h5>Implant Mode</h5>
            <p>Precise, Efficient, Stable &amp; Controlled</p>
          </div>
          <div class="ss-mode-item">
            <h5>Surgical Mode</h5>
            <p>Precise Control, Efficient &amp; Safe</p>
          </div>
          <div class="ss-mode-item">
            <h5>Piezo Mode</h5>
            <p>Selective Cutting, Enhanced Safety</p>
          </div>
        </div>
        <div class="ss-mode-image">
          <img :src="assets.modes" alt="Three modes">
        </div>
      </section>

      <!-- ================= 4. 01 Piezosurgery ================= -->
      <section class="ss-section ss-bone">
        <div class="ss-section-head">
          <div class="ss-qr">
            <img :src="assets.qrBone" alt="QR">
            <p>Scan for more cases.</p>
          </div>
          <div class="ss-section-title tone-green ss-section-title-img">
            <img :src="assets.boneTitle" alt="01 Piezosurgery">
          </div>
        </div>

        <div class="ss-wide-img gudao">
          <img :src="assets.boneHandle1" alt="Piezosurgery handpiece">
        </div>

        <div class="ss-tags">
          <div>
            <h5>Bone Cutting</h5>
          </div>
          <div>
            <h5>Perio</h5>
          </div>
          <div>
            <h5>Endo</h5>
          </div>
          <div>
            <h5>Rinsing</h5>
          </div>
        </div>

        <div class="ss-detail">
          <div class="ss-detail-text">
            <h5>Minimally Invasive Cutting<br>while Preserving Soft Tissues</h5>
            <div class="ss-params">
              <div class="ss-param">
                <p class="p-orange">Lateral Tip Amplitude: &le;30 &mu;m</p>
                <p class="p-grey">Reduced surgical trauma, faster recovery</p>
              </div>
              <div class="ss-param">
                <p class="p-orange">Operating Frequency: 30 kHz &plusmn; 4.5 kHz</p>
                <p class="p-grey">Selective cutting for enhanced surgical safety</p>
              </div>
            </div>
          </div>
          <div class="ss-detail-img">
            <img :src="assets.bone" alt="Piezosurgery in use">
          </div>
        </div>

        <div class="ss-center-title power">
          <h5><span class="t-orange">10 Adjustable</span> Power Levels<br/>Dual Output Modes</h5>
          <p>Enhanced handpiece for improved energy transfer efficiency<br/>Boosted power output and one-touch handpiece light control</p>
        </div>

        <div class="ss-wide-img shoubin">
          <img :src="assets.boneHandle2" alt="Bone handpiece 2">
        </div>

        <div class="ss-efficiency">
          <div class="ss-efficiency-left">
            <h5><span class="t-orange">34.6% Higher</span><br>Cutting Efficiency</h5>
            <p class="sub">Test condition: bovine cortical bone,<br>20 mm cutting width &times; 3.3 mm thickness</p>
            <div class="ss-bars">
              <div class="ss-bar-row">
                <i class="ss-bar ss-bar-hot ss-bar-a"></i>
                <span class="ss-bar-label">Surgic Star: 20.41s</span>
              </div>
              <div class="ss-bar-row">
                <i class="ss-bar ss-bar-hot ss-bar-b"></i>
                <span class="ss-bar-label">3rd-Gen Piezo Bone Surgery Unit: 27.48s</span>
              </div>
            </div>
          </div>
          <div class="ss-two-modes">
            <div class="ss-two-mode">
              <div class="ss-two-mode-img">
                <img :src="assets.boost" alt="Hard Mode" style="height: 93px;">
              </div>
              <h6>Hard Mode</h6>
              <p>Automatically increases<br>power under applied<br>pressure for more<br>efficient cutting</p>
            </div>
            <div class="ss-two-mode">
              <div class="ss-two-mode-img">
                <img :src="assets.stable" alt="Soft Mode" style="height: 93px;">
              </div>
              <h6>Soft Mode</h6>
              <p>Maintains consistent<br>power under applied<br>pressure for stable<br>cutting performance</p>
            </div>
          </div>
        </div>

        <div class="ss-center-title enhance">
          <h5>Boost</h5>
          <p class="ss-big-orange number">25%</p>
          <p class="sub">instant power increase</p>
        </div>

        <div class="ss-screen-img">
          <img :src="assets.screenUI" alt="Screen">
        </div>
      </section>

      <!-- ================= 5. 02 Surgical ================= -->
      <section class="ss-section ss-motor micro-power ss-surgical">
        <div class="ss-section-head">
          <div class="ss-qr">
            <img :src="assets.qrBone" alt="QR">
            <p>Scan for more cases.</p>
          </div>
          <div class="ss-section-title ss-section-title-img surgical">
            <img :src="assets.surgicalTitle" alt="02 Surgical">
          </div>
        </div>

        <div class="ss-wide-img surgical-handle">
          <img :src="assets.motorHandle" alt="Surgical handpiece">
        </div>

        <div class="ss-tags">
          <div>
            <h5>Bone Removal</h5>
          </div>
          <div>
            <h5>Tooth Sectioning</h5>
          </div>
          <div>
            <h5>Space Creation</h5>
          </div>
          <div>
            <h5>Socket Debridement</h5>
          </div>
        </div>

        <div class="ss-dark-banner">
          <div class="ss-dark-img">
            <img :src="assets.darkBanner" alt="Sterile irrigation">
          </div>
          <div class="ss-dark-text">
            <div class="ss-dark-item">
              <h5>Without High-Pressure Airflow</h5>
              <p>Helps minimize the risk of postoperative<br>subcutaneous emphysema</p>
            </div>
            <div class="ss-dark-item">
              <h5>Sterile Saline Irrigation</h5>
              <p>Helps reduce the risk of surgical site infection<br>and meets aseptic standards</p>
            </div>
          </div>
        </div>

        <div class="ss-motor-figure">
          <div class="ss-center-title">
            <h5>High-Performance Brushless Motor</h5>
            <p>Precise speed control, more powerful</p>
            <p>More durable, quieter operation</p>
          </div>

          <div class="ss-motor-img">
            <img :src="assets.brushless" alt="Brushless motor">
            <div class="ss-motor-params">
              <div class="ss-param">
                <p class="ss-big-orange">80N&middot;cm</p>
                <p class="p-grey">output torque</p>
              </div>
              <div class="ss-param">
                <p class="ss-big-orange">126000r/min</p>
                <p class="p-grey">Max. speed</p>
              </div>
            </div>
          </div>
        </div>

        <div class="ss-speed-bar">
          <div class="ss-speed-row">
            <span>Speed</span>
            <span class="ss-speed-value">110000</span>
            <span>r/min</span>
          </div>
          <div class="ss-slider">
            <i class="ss-slider-track"></i>
            <i class="ss-slider-fill" style="width: 83.5%"></i>
          </div>
          <div class="ss-speed-hint">
            <p class="ss-hint-plus">+</p>
            <span>With 1:3 speed-increasing contra-angle: up to 126000r/min</span>
            <i class="ss-hint-minus"></i>
          </div>
        </div>

        <div class="ss-cool">
          <img class="ss-cool-img" :src="assets.threeStage" alt="Triple spray contra-angle handpiece">

          <div class="ss-cool-text">
            <h5>Triple Spray<br/>Contra-Angle<br/>Handpiece System</h5>
            <ul>
              <li>Compatible with various bur lengths</li>
              <li>Optimized cooling for burs</li>
              <li>Anti-retraction design</li>
              <li>Enhanced safety and reliability</li>
            </ul>
          </div>

          <div class="ss-bearing">
            <h5 class="ss-bearing-title">German Bearings</h5>
            <div class="ss-bearing-sub">
              <p>Smoother rotation for more precise cutting</p>
              <p>Compatible with various contra-angle gear ratios</p>
            </div>

            <div class="ss-ratio">
              <img :src="assets.ratio1" alt="1:1 1:3 1:4.2 1:5">
            </div>

            <img class="ss-bearing-img" :src="assets.bearing" alt="German bearings">

            <p class="ss-chart-cap">Noise Level (dB)</p>
            <img class="ss-chart-plot" :src="assets.bearingChart" alt="Noise level chart">

            <div class="ss-chart-x">
              <div>
                <p>Speed: 300RPM</p>
                <p>Torque: 3.0N&middot;cm</p>
              </div>
              <div>
                <p>Speed: 350RPM</p>
                <p>Torque: 2.0N&middot;cm</p>
              </div>
              <div>
                <p>Speed: 500RPM</p>
                <p>Torque: 2.0N&middot;cm</p>
              </div>
            </div>

            <div class="ss-chart-legend">
              <span class="lg-surgic">Surgic Star</span>
              <span class="lg-a"><i></i>Brand A</span>
              <span class="lg-b"><i></i>Brand B</span>
            </div>
          </div>
        </div>
      </section>

      <!-- ================= 6. 03 Implant ================= -->
      <section class="ss-section ss-implant">
        <div class="ss-section-head">
          <div class="ss-qr">
            <img :src="assets.qrImplant" alt="QR">
            <p>Scan for more cases.</p>
          </div>
          <div class="ss-implant-logo">
            <img :src="assets.implantLogo" alt="Implant">
          </div>
        </div>

        <div class="ss-wide-img">
          <img :src="assets.implantWide" alt="Implant handpiece">
        </div>

        <div class="preset">
          <div class="ss-center-title">
            <h5>5 Preset Implant Programs</h5>
          </div>
          <div class="ss-program-list">
            <img :src="assets.program" alt="Programs">
            <p>Marking</p>
            <p>Pilot Drilling</p>
            <p>Template Drilling</p>
            <p>Implanting</p>
            <p>Rinsing</p>
          </div>
        </div>

        <div class="ss-detail parallel">
          <div class="ss-detail-text">
            <h5>Swiss Brushless Motor<br/>Powerful Performance</h5>
            <p class="p-grey">Consistent torque maintenance during implant placement</p>
            <p class="p-grey">Maintains continuous torque output for precise implant placement</p>
            <p class="p-grey">Real-time speed and torque display with peak torque indication</p>
            <p class="p-grey">LED motor for enhanced visibility throughout implant surgery</p>
          </div>
          <div class="ss-detail-img ss-card-img">
            <img :src="assets.swiss" alt="Swiss brushless motor">
          </div>
        </div>

        <div class="ss-torque-card">
          <div class="ss-torque-visual">
            <img :src="assets.torque" alt="Implant drilling">
          </div>
          <div class="ss-torque-info">
            <div class="ss-torque-row">
              <span>Torque</span>
              <span class="ss-torque-value">35</span>
              <span>N&middot;cm</span>
            </div>
            <div class="ss-slider">
              <i class="ss-slider-track"></i>
              <i class="ss-slider-fill ss-slider-fill-cyan" style="width: 54%"></i>
            </div>
            <p class="p-grey ss-torque-info-p">With 20:1 reduction contra-angle: max. torque</p>
            <p class="ss-big-orange">80N&middot;cm</p>
          </div>
        </div>

        <div class="ss-torque-hold">
          <h5>Torque Holding Function</h5>
          <p class="p-grey ss-torque-hold-f-p">Maintains the required insertion torque for adequate bone compression<br/>Ensures consistent screw preload, eliminating the spring fatigue and calibration drift of manual torque wrenches</p>
          <span class="ss-chart-note">Implant preload after<br/>alveolar bone recoil</span>
          <div class="ss-hold-charts">
            <div class="ss-hold-chart">
              <img :src="assets.torqueHold" alt="Torque hold chart">
            </div>
            <div class="ss-hold-legend">
              <div class="ss-legend-item">
                <h6 class="t-green">Woodpecker implant motor:</h6>
                <p>maintains torque at the preset<br/>level until the foot pedal is<br/>released, for better control of<br/>insertion force and improved<br/>implant survival rate</p>
              </div>
              <div class="ss-legend-item">
                <h6 class="t-red">Traditional implant motors:</h6>
                <p>stop output immediately upon reaching<br/>the preset torque, potentially affecting<br/>the intended preload</p>
              </div>
            </div>
          </div>
        </div>

        <div class="collocation">
          <div class="g-t-txt">
            <p>Compatible with implant contra-angle handpieces of various speed ratios</p>
            <img class="ss-ratio2" :src="assets.ratio2" alt="16:1 20:1 27:1">
          </div>

          <div class="ss-two-col">
            <div class="ss-col">
              <h5>German Bearings</h5>
              <p class="p-grey">Handpiece runout:<br/><span class="p-orange">&lt; 20 &mu;m</span></p>
              <div class="ss-card-img">
                <img :src="assets.bearing2" alt="German bearings">
              </div>
            </div>
            <div class="ss-col">
              <h5>Hygienic Head System</h5>
              <p class="p-grey">Anti-retraction design<br/>Enhanced safety and reliability</p>
              <div class="ss-card-img">
                <img :src="assets.hygiene" alt="Hygienic handpiece">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ================= 7. 7-inch Color Interface ================= -->
      <section class="ss-screen-banner">
        <div class="ss-screen-banner-img">
          <img :src="assets.screen" alt="7-inch interface">
        </div>
        <div class="ss-screen-banner-text">
          <h5><span class="t-orange">7-Inch</span> Color Touchscreen</h5>
          <p>One-touch mode switching with QR Code<br/>recognition for handpieces and<br/>contra-angle handpieces.<br/>Automatic mode switching with voice guidance<br/>Effectively prevents operating errors</p>
        </div>
      </section>

      <!-- ================= 8. Bicolor Smart Interface ================= -->
      <section class="ss-dual-theme">
        <div class="ss-center-title">
          <h5>Bicolor Smart Interface</h5>
          <p>Clear and intuitive user interface<br/>Easy mode identification</p>
        </div>
        <div class="ss-theme-list">
          <div class="ss-theme-item">
            <img :src="assets.theme1" alt="Blue theme">
            <p><span class="t-blue">Blue:</span> Implant motor&middot;Surgical motor</p>
          </div>
          <div class="ss-theme-item">
            <img :src="assets.theme2" alt="Green theme">
            <p><span class="t-green">Green:</span> Pterygography</p>
          </div>
        </div>
      </section>

      <!-- ================= 9. Dual Water Channel ================= -->
      <section class="ss-water">
        <div class="ss-center-title">
          <h5>Dual Irrigation Supply System</h5>
          <p>Automatic irrigation line switching based on the selected operating mode<br/>Color-coded tubing matches interface colors to prevent incorrect installation</p>
        </div>
        <div class="ss-water-img">
          <img :src="assets.water" alt="Dual irrigation supply system">
        </div>
      </section>

      <!-- ================= 10. Wireless Foot Pedal ================= -->
      <section class="ss-foot">
        <div class="ss-center-title">
          <h5>Wireless Foot Pedal</h5>
          <p>Flexible, hands-free operation<br/>No cables in the working area<br/>Unrestrained placement in the operatory<br/>Greater flexibility and convenience during procedures</p>
        </div>
        <div class="ss-foot-img">
          <img :src="assets.pedal" alt="Wireless foot pedal">
        </div>
      </section>

      <!-- ================= 11. Meets Diverse Clinical Needs ================= -->
      <section class="ss-cart">
        <div class="ss-cart-img">
          <img :src="assets.cart" alt="Surgic Star on a mobile dental cart">
        </div>
        <div class="ss-center-title">
          <h5>Meets Diverse Clinical Needs</h5>
          <p>One portable system for multiple clinical applications<br/>Optional mobile dental cart</p>
        </div>
        <!-- ================= 12. Specifications ================= -->
        <section class="ss-specs">
          <div class="ss-specs-col ss-specs-left">
            <p class="ss-spec-line"><span class="ss-specs-label">Model:</span>Surgic Star</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Main Unit Dimensions:</span>267mm&times;284mm&times;136mm</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Power Supply:</span>200V-240V~ 50Hz/60Hz, 180VA</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Motor Speed Range:</span>300-42000rpm</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Torque Range (20:1):</span>5N&middot;cm-80N&middot;cm</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Motor Dimensions:</span>&Phi;21.5mm&times;110mm</p>
          </div>
          <div class="ss-specs-col ss-specs-right">
            <p class="ss-spec-line"><span class="ss-specs-label">Motor Weight:</span>140g</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Motor Functions:</span>Forward/Reverse, Automatic Torque Calibration, Torque Maintenance During Implant Placement</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Peristaltic Pump Flow Rate:</span>0-120mL/min</p>
            <p class="ss-spec-line"><span class="ss-specs-label">Wireless Foot Pedal:</span>Flexible Control of Operating Modes, Power, Irrigation Flow,</p>
            <p class="ss-spec-line">Programs, Forward/Reverse, and Speed; IPX6 Water Resistance Rating</p>
          </div>
        </section>
      </section>

      <video-modal ref="videoModalRef"></video-modal>
    </div>
  </div>
</template>

<script>
import circularProgress from "../components/progress-circle.vue";
import videoModal from '../components/video-modal.vue'

import viewButton from './components/button.vue'

export default {
  name: 'surgic-star',
  components: {
    circularProgress,
    videoModal,
    viewButton
  },
  data() {
    return {
      // All assets are local, resolved via require so they bundle with the project.
      assets: {
        hero: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/20c04b946613a79889e30b5685d021ab.jpg",
        // Hero 产品名称「Surgic Star」整图素材（本地 pic/，尚未上传 OSS）
        productName: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/b104fa0a9e948c1c02bca64c81c981e1.png",
        modes: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/56927cca680a9340f11a4a161aa0f300.jpg",
        bone: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/c486b97672fc9ab8c7926e198da3fa7d.png",
        boneHandle1: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/39541b4429aa507b138e04bcec1d5001.png",
        boneHandle2: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/daa23aa009e9ab063dc48cac11115876.png",
        // 骨刀.png is the "1 PIEZOSURGERY" section logotype (numeral + wordmark + rule)
        boneTitle: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/62395d0f007c00d01fb5e7963be69915.png",
        screenUI: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/4435524e432a7742e13d494311517b81.png",
        boost: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/3b917db0d8e89e74d11fea3928088fa8.png",
        stable: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/cd0faa9b20cf6de1ec85719a7816e7f7.png",
        motorHandle: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/fed0eea4b8bee1b737bc0183f4aea260.png",
        // 微动力.png is the "2 SURGICAL" section logotype (numeral + wordmark + rule)
        surgicalTitle: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/4ec86180f05c876f626fa5a0076bf9a8.png",
        darkBanner: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/35836cdc387402239f5b2ee6d737ba58.jpg",
        brushless: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/1ef89df0e429728487c1d0bc3d11e6d9.jpg",
        threeStage: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/f80f77de1122a64f608d8759b73f7ace.png",
        bearing: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/e169a96b48ba7de55e19221ad4c384f7.png",
        // German Bearings 转速比「1:1 1:3 1:4.2 1:5」整图素材（本地 pic/，尚未上传 OSS）
        ratio1: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/cb8e333f832f63694525b58517866814.png",
        ratio2: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/4663a0274ab0dc5e5a0f930b7895b07d.png",
        bearingChart: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/be1d26652c349fedece3961abd7b9d00.png",
        implantWide: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/3e8e000f4cfb8c2caabc5734f004b53e.png",
        implantLogo: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/8d1e5fe3ab6fb2b89c276c98d7e26b29.png",
        program: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/5867b22e1151b198798c61baae3dd217.png",
        swiss: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/3cd70adfff394ddf7c88d83ec408738b.png",
        torque: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/ad647bdbaddc0ea3075a08c7ebc866e9.png",
        torqueHold: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/6c674538781698f939be8d0de4a549d6.png",
        bearing2: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/091c45ac4e232e05c97224f13fc2bf1c.png",
        hygiene: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/fa36a0818d6477eeea7a3b8073a4a27f.png",
        screen: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/4645209e580038ce71cce8c91f029dca.jpg",
        theme1: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/821883b3907c36486b70ed22341fa6ef.png",
        theme2: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/d5587e820d7d862589dd59c192f616c5.png",
        water: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/ca144065548f3d003ee903b7e10a25e8.png",
        pedal: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/4823d15ec645ca782f8a17e31414f84c.png",
        cart: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/5cf3662688f112a3f329c02d798bc005.jpg",
        qrBone: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/3a5f05edfd24f3959a6981fe3b6b8571.png",
        qrMotor: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/95ff07bead1799a0f6df74dbcaedda74.png",
        qrImplant: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/699cf891b442fac15591fff33d581d35.png",
        // TODO(user): the EN design has no obvious 4-icon tag set; reuse a single
        // decorative icon for the tag pills. Replace with the real tag icon if one exists.
        tagIcon: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/5c2e720f2e1038426194bc105ffe8355.png"
      },
      videoList: [
        {
          ref: 'promotionalRef',
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/bb7d6d625001834825174308927/mdXjDUaAQk4A.mp4',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/6897317e5001834825261828217/GOZMfxpr3TcA.mp4'
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initVideo()
    })
    window.addEventListener('scroll', this.onScroll, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.onScroll, false)
    })
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    handleVisibility(isVisible, index) {
      const ref = this.videoList[index].ref;
      if (isVisible && !this.videoList[index].hasEntered) {
        this.$refs[ref].play().catch(e => console.log(ref + " video play failed:", e));
        this.videoList[index].playing = true
        this.videoList[index].hasEntered = true
        this.videoList[index].hasLeft = false
      } else if (!isVisible && !this.videoList[index].hasLeft) {
        this.$refs[ref].pause()
        this.videoList[index].playing = false
        this.videoList[index].hasLeft = true
        this.videoList[index].hasEntered = false
      }
    },
    openVideoModal(url) {
      this.$refs.videoModalRef.open(url)
    },
    togglePlay(index) {
      const item = this.videoList[index]
      item.playing = !item.playing
      const el = this.$refs[item.ref]
      if (!el) return
      if (item.playing) {
        el.play().catch(e => console.log(item.ref + ' video play failed:', e))
      } else {
        el.pause()
      }
    },
    initVideo() {
      const el = this.$refs[this.videoList[0].ref]
      if (!el) return
      el.addEventListener('timeupdate', this.onVideoProgress)
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            if (!this.videoList[0].playing) {
              el.play().catch(() => {})
              this.videoList[0].playing = true
            }
          } else {
            if (this.videoList[0].playing) {
              el.pause()
              this.videoList[0].playing = false
            }
          }
        })
      }, { threshold: [0, 0.3, 1.0] })
      this.observer.observe(el)
    },
    onVideoProgress(event) {
      const video = event.target
      if (!video.duration) return
      this.videoList[0].progress = ((video.currentTime / video.duration) * 100).toFixed(2)
    },
    onScroll() {}
  }
};
</script>

<style>
.surgic-star h1, .surgic-star h2, .surgic-star h3,
.surgic-star h4, .surgic-star h5, .surgic-star h6,
.surgic-star p {
  padding: 0;
  margin: 0;
}

.surgic-star {
  --c-dark: #1b1b1b;
  --c-grey: #7d7d7d;
  --c-orange: #ff7033;
  --c-green: #008533;
  --c-blue: #3baeff;
  --c-teal: #0f9a9a;
  font-family: 'MiSans-Medium', -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--c-dark);
  background: #ffffff;
  overflow-x: hidden;
}

.surgic-star .special-body {
  width: 100%;
  position: relative;
}

/* 通用文本 */
.surgic-star h5 {
  font-family: 'MiSans-Demibold', -apple-system, 'PingFang SC', sans-serif;
  font-weight: 600;
  color: var(--c-dark);
}

.surgic-star p {
  font-family: 'MiSans-Medium', -apple-system, 'PingFang SC', sans-serif;
  color: var(--c-dark);
}
.surgic-star .p-grey {
  color: var(--c-grey);
  font-size: 16px;
  line-height: 1.7;
}
.surgic-star .p-orange {
  color: var(--c-orange);
  font-weight: 600;
}
.surgic-star .t-orange { color: var(--c-orange); }
.surgic-star .t-green { color: var(--c-green); }
.surgic-star .t-blue { color: var(--c-blue); }
.surgic-star .t-teal { color: var(--c-teal); }
.surgic-star .t-red { color: #e85656; }

.surgic-star img {
  display: block;
  width: 100%;
}

/* ============ 1. Hero ============ */
.surgic-star .ss-hero {
  text-align: center;
  position: relative;
}

.ss-hero-title-container {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  top: 142px;
}
.surgic-star .ss-hero-sub {
  /* 设计 ink x867-1400 w534 / y171-207 h37（2268 稿）→ ÷K1.18125 = 452×31.3 CSS px
     字重/字号按逐字块宽拟合：MiSans-Medium 28.6px + 字距 0 → 452×31，NCC 0.92
     （Normal 30px 整行宽也刚好，但笔画比设计细，NCC 仅 0.80） */
  font-size: 28.6px;
  letter-spacing: 0;
  line-height: 31px;
  color: #1A1A1A;               /* 设计实测 (26,26,26) */
  font-family: 'MiSans-Medium', -apple-system, 'PingFang SC', sans-serif;
}
.surgic-star .ss-hero-title {
  /* 产品名称改用整图 pic/产品名称.png（1448×213，ink 满画布）
     设计 ink x917-1350 w434 / y246-309 h64（2268 稿）→ 367.4×54.2 CSS px */
  display: block;
  width: 367.4px;
  height: 54.2px;
  margin: 35px auto 0;
  /* 素材墨色 #1C1C1C，设计稿标题为纯黑 #000000（实测 p2≈2），压黑后一致 */
  filter: brightness(0);
}
.surgic-star .ss-hero-product {
}

.surgic-star .ss-hero-product img {
  width: 100%;
}

/* ============ 2. 视频 Banner ============ */
.surgic-star .ss-video-banner {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #111;
}
.surgic-star .ss-video-banner .ss-video-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.surgic-star .ss-video-banner .ss-video-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
}
.surgic-star .ss-video-banner .ss-video-text {
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 50%;
  top: 220px;
  transform: translateX(-50%);
}
.surgic-star .ss-video-banner .ss-video-text h4 {
  font-family: 'MiSans-Demibold', sans-serif;
  color: #ffffff;
  font-size: 42px;
  font-weight: normal;
  line-height: 115.5px;
  letter-spacing: 0;
  white-space: nowrap;
}
.surgic-star .ss-video-banner .ss-video-text .button {
  margin-top: 111.5px;
}
.surgic-star .ss-video-banner .progress {
  position: absolute;
  right: 40px;
  top: 30px;
  z-index: 3;
}

/* ============ 3. 三种模式 ============ */
.surgic-star .ss-modes {
  padding: 173px 0 0 0;
}
.surgic-star .ss-mode-list {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.surgic-star .ss-mode-item {
  width: 362px;
  text-align: center;
}
.surgic-star .ss-mode-item h5 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 42px;
  font-weight: normal;
  line-height: 50.4px;
  letter-spacing: 0;
  color: #000000;
  white-space: nowrap;
}
.surgic-star .ss-mode-item p {
  margin-top: 29px;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 17.5px;
  font-weight: normal;
  line-height: 1;
  letter-spacing: 0;
  color: #fc6e2d;
  white-space: nowrap;
}
.surgic-star .ss-mode-image {
  width: 1176px;
  margin: 131px auto 0 auto;
}

/* ============ 章节标题头（数字 + 名称 + 二维码）============ */
.surgic-star .ss-section {
  padding: 120px 0 0 0;
}
.surgic-star .ss-section-head {
  position: relative;
  width: 100%;
  text-align: center;
}
.surgic-star .ss-section-head .ss-qr {
  position: absolute;
  left: 370px;
  top: 40px;
  width: 96px;
}
.surgic-star .ss-section-head .ss-qr p {
  font-size: 10px;
  margin-top: 5px;
  color: var(--c-grey);
}
.surgic-star .ss-section-title {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.surgic-star .ss-section-title.ss-section-title-img {
  width: 226px;
  margin-top: 30px;
}
.surgic-star .ss-section-title.ss-section-title-img img {
  display: block;
  width: 100%;
}
.surgic-star .ss-section-title .ss-num {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 150px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -4px;
}
.surgic-star .ss-section-title .ss-name {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 46px;
  font-weight: 700;
  margin-top: -20px;
}
.surgic-star .tone-green .ss-num, .surgic-star .tone-green .ss-name { color: var(--c-green); }
.surgic-star .tone-blue .ss-num, .surgic-star .tone-blue .ss-name {
  color: var(--c-blue);
}
.surgic-star .tone-teal .ss-num, .surgic-star .tone-teal .ss-name { color: var(--c-teal); }

.surgic-star .tone-blue {
  width: 180px;
}

.surgic-star .tone-blue img {
  display: block;
}
.surgic-star .ss-wide-img {
  position: relative;
}

.surgic-star .ss-wide-img img {
  width: 100%;
}

.surgic-star .ss-wide-img.shoubin img {
  margin-top: -130px;
}

.surgic-star .ss-wide-img.gudao {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 240px;
}
.surgic-star .ss-wide-img.gudao img {
  display: block;
  width: 1900px;
  top: -140px;
  position: absolute;
}

/* 标签四连 */
.surgic-star .ss-tags {
  display: flex;
  justify-content: center;
}

.surgic-star .ss-tags div {
  width: 250px;
  position: relative;
  margin-left: 53px;

}
.surgic-star .ss-tags div:first-child {
  margin-left: 0;
}
.surgic-star .ss-tags h5 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,0%);
  font-size: 28px;
}


.surgic-star .ss-detail {
  width: 1180px;
  margin: 90px auto 0 auto;
}
.surgic-star .ss-detail-text {
  padding-top: 40px;
}
.surgic-star .ss-detail-text h5 {
  font-size: 50px;
  font-weight: 700;
  line-height: 1.4;
}
.surgic-star .ss-params {
  margin-top: 34px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.surgic-star .ss-params .ss-param .p-orange {
  font-size: 36px;
}

.surgic-star .ss-params .ss-param .p-grey {
  font-size: 21px;
  margin-top: 12px;
}
.surgic-star .ss-param + .ss-param {
  margin-left: 70px;
}
.surgic-star .ss-detail-img {
  width: 1170px;
  border-radius: 24px;
  overflow: hidden;
  margin-top: 30px;
}

.surgic-star .ss-detail-img img {
  display: block;
  width: 100%;
}

/* 居中标题 */
.surgic-star .ss-center-title {
  text-align: center;
  margin-top: 170px;
}
.surgic-star .ss-center-title h5 {
  font-size: 50px;
  font-weight: 700;
  line-height: 1.5;
}

.surgic-star .ss-center-title.power p {
  color: var(--c-grey);
  margin-top: 37px;
}

.surgic-star .ss-center-title p {
  margin-top: 18px;
  font-size: 19px;
  color: var(--c-orange);
}

.surgic-star .ss-center-title p {
  margin-top: 18px;
  font-size: 19px;
  color: var(--c-orange);
}
.surgic-star .ss-big-orange {
  font-family: 'MiSans-Demibold', sans-serif;
  color: var(--c-orange);
  font-size: 120px !important;
  font-weight: bold;
}

.surgic-star .ss-big-orange.number {
  margin-top: 0px!important;
}
.surgic-star .ss-ratio-line span {
  font-size: 32px;
  font-weight: 700;
  margin: 0 8px;
}

/* 效率对比 */
.surgic-star .ss-efficiency {
  margin-top: -120px;
  margin-left: 550px;
  display: flex;
  justify-content: flex-start;
}

.surgic-star .ss-efficiency .ss-efficiency-left {
}
.surgic-star .ss-efficiency .ss-efficiency-left .sub {
  margin-top: 14px;
  font-size: 19px;
  letter-spacing: 0.5px;
  font-weight: bold;
}
.surgic-star .ss-efficiency h5 {
  font-size: 50px;
  font-weight: 700;
}
.surgic-star .ss-efficiency h5 .t-orange {
  font-family: 'MiSans-Demibold', sans-serif;
}
.surgic-star .ss-efficiency > .p-grey {
  text-align: center;
  margin-top: 18px;
}
.surgic-star .ss-bars {
}
.surgic-star .ss-bar-row {
  position: relative;
}
.surgic-star .ss-bar-row .ss-bar-label {
  font-size: 20px;
  display: block;
  color: var(--c-grey);
  margin-top: 10px;
}
.surgic-star .ss-bar {
  display: block;
  height: 14px;
  margin-top: 30px;
}
.surgic-star .ss-bar-hot {
  background: var(--c-orange);
}
.surgic-star .ss-bar-cold {
  background: #cfcfcf;
}
.surgic-star .ss-two-modes {
  display: flex;
  justify-content: flex-start;
}
.surgic-star .ss-two-modes h6 {
  margin-top: 20px;
}

.surgic-star .ss-two-modes p {
  font-size: 22px;
}

.surgic-star .ss-two-mode {
  margin-top: 20px;
  margin-left: 170px;
}
.surgic-star .ss-two-mode:nth-child(2){
  margin-left: 100px;
}
.surgic-star .ss-two-mode .ss-two-mode-img {
  width: 150px;
}
.surgic-star .ss-two-mode .ss-two-mode-img img{
  width: 100%;
  height: 88px;
}
.surgic-star .ss-two-mode h6 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #000000;
}
.surgic-star .ss-two-mode p {
  margin-top: 14px;
  font-size: 18px;
  color: var(--c-grey);
  line-height: 1.7;
}

.surgic-star .ss-screen-img {
  width: 100%;
  margin-top: -100px;
}

.surgic-star .ss-screen-img img {
  display: block;
  width: 100%;
}

/* ============ 5. 微动力 ============ */
.surgic-star .ss-dark-banner {
  position: relative;
}

.surgic-star .ss-dark-banner .ss-dark-img {
  margin-top: 100px;
}
.surgic-star .ss-dark-banner .ss-dark-img img {
  display: block;
}
.surgic-star .ss-dark-banner .ss-dark-text {
  position: absolute;
  left: 500px;
  top: 170px;
}
.surgic-star .ss-dark-banner .ss-dark-item + .ss-dark-item {
  margin-top: 150px;
}
.surgic-star .ss-dark-banner .ss-dark-item h5 {
  color: #ffffff;
  font-size: 50px;
  font-weight: 700;
}
.surgic-star .ss-dark-banner .ss-dark-item p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 19px;
  margin-top: 10px;
}

.surgic-star .ss-motor-figure {
  position: relative;
  width: 100%;
}
.surgic-star .ss-motor-figure .ss-center-title {
  margin-top: 120px;
}
.surgic-star .ss-motor-figure .ss-center-title p {
  color: var(--c-grey);
  margin-top: 10px;
}
.surgic-star .ss-motor-figure .ss-motor-img {
  width: 800px;
  margin: 60px auto 0 auto;
  position: relative;
}

.surgic-star .ss-motor-figure .ss-motor-img img{
  display: block;
}
.surgic-star .ss-motor-params {

}

.surgic-star .ss-motor-params .ss-param {
  position: absolute;

}

.surgic-star .ss-motor-params .ss-param p {
  font-size: 20px!important;
}
.surgic-star .ss-motor-params .ss-param:nth-child(1){
  left: -18px;
  top: 424px;
  text-align: right;
}
.surgic-star .ss-motor-params .ss-param .ss-big-orange {
  font-size: 50px!important;
}
.surgic-star .ss-motor-params .ss-param:nth-child(2){
  right: -140px;
  top: 424px;
}
.surgic-star .ss-motor-params .ss-param .p-grey {
  font-size: 15px;
}

.surgic-star .ss-speed-bar {
  width: 890px;
  margin: 70px auto 0 auto;
}
.surgic-star .ss-speed-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 26px;
  color: #333;
}
.surgic-star .ss-speed-row .ss-speed-value {
  color: var(--c-orange);
  font-size: 34px;
  margin: 0 10px;
  letter-spacing: 2px;
}
.surgic-star .ss-slider {
  position: relative;
  height: 16px;
  margin: 16px 0;
}
.surgic-star .ss-slider .ss-slider-track {
  position: absolute;
  inset: 0;
  background: #e2e2e6;
  border-radius: 50px;
}
.surgic-star .ss-slider .ss-slider-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 16px;
  background: linear-gradient(to right, #67d2e1, #2394ff);
  border-radius: 50px;
}
.surgic-star .ss-slider .ss-slider-fill-cyan {
  background: linear-gradient(to right, #34d3d3, #14a2c8);
}

.surgic-star .ss-torque-info .ss-slider .ss-slider-fill-cyan {
  background: linear-gradient(to right, #67d2e1, #2394ff);
}
.surgic-star .ss-torque-info .p-grey.ss-torque-info-p {
  font-size: 17.2px!important;
}
.surgic-star .ss-slider .ss-slider-knob {
  position: absolute;
  top: 50%;
  width: 22px;
  height: 22px;
  margin-top: -11px;
  margin-left: -11px;
  border-radius: 50%;
  background: #ffffff;
  border: 3px solid #2f6bff;
}
.surgic-star .ss-speed-hint {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  color: #333;
}
.surgic-star .ss-speed-hint p {
  font-size: 60px;
}
.surgic-star .ss-speed-hint span {
  font-size: 24px;
}

.surgic-star .ss-ratio-list {
  display: flex;
  justify-content: center;
  margin-top: 22px;
}
.surgic-star .ss-ratio-list span {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 50px;
  color: var(--c-orange);
  margin: 0 26px;
}

.surgic-star .ss-chart-img {
  width: 1000px;
  margin: 70px auto 0 auto;
}

/* ============ 6. 种植 ============ */
.surgic-star .ss-program-list {
  display: flex;
  justify-content: center;
  margin-top: 55px;
}
.surgic-star .ss-program-item {
  width: 220px;
  text-align: center;
  margin: 0 10px;
}
.surgic-star .ss-program-item img {
  border-radius: 10px;
}
.surgic-star .ss-program-item p {
  margin-top: 16px;
  font-size: 20px;
  color: #333;
}

.surgic-star .ss-card-img {
  border-radius: 24px;
  overflow: hidden;
}

.surgic-star .ss-torque-card {
  display: flex;
  align-items: center;
  width: 1180px;
  margin: 90px auto 0 auto;
  border-radius: 24px;
  overflow: hidden;
}
.surgic-star .ss-torque-visual {
  width: 680px;
  margin-top: 80px;
}
.surgic-star .ss-torque-info {
  width: 435px;
  margin-top: 90px;
  margin-left: 63px;
}
.surgic-star .ss-torque-info .p-grey {
  font-size: 19px!important;
}
.surgic-star .ss-torque-info .ss-slider {
  margin-top: 0px;
}
.surgic-star .ss-torque-info .ss-slider-track {
  background-color: #494c57;
}
.surgic-star .ss-torque-info .ss-torque-row .ss-torque-value {
  color: #000000;
  font-size: 30px;
}
.surgic-star .ss-torque-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 20px;
  color: #333;
}
.surgic-star .ss-torque-row .ss-torque-value {
  font-size: 50px!important;
  color: #000000;
}
.surgic-star .ss-torque-row span {
  font-size: 28px!important;
  color: var(--c-grey);
}
.surgic-star .ss-torque-info .p-grey {
  margin-top: 20px;
}
.surgic-star .ss-torque-info .ss-big-orange {
  font-size: 56px !important;
  margin-top: 4px;
}

.surgic-star .ss-torque-hold {
  width: 1180px;
  margin: 170px auto 0 auto;
}
.surgic-star .ss-torque-hold h5 {
  font-size: 53px;
  font-weight: bold;
}
.surgic-star .ss-torque-hold > .p-grey {
  margin-top: 20px;
  font-size: 19px;
}
.surgic-star .ss-torque-hold .ss-hold-chart {
  width: 565px;
  margin-top: 14px;
}

.surgic-star .ss-torque-hold-f-p {
  font-size: 17.3px!important;
  letter-spacing: 0.1px;
}
.surgic-star .ss-hold-charts {
  display: flex;
  align-items: center;
  margin-top: 40px;
}
.surgic-star .ss-hold-chart {
  width: 480px;
  flex-shrink: 0;
}
.surgic-star .ss-hold-legend {
  margin-left: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 46px;
}
.surgic-star .ss-legend-item + .ss-legend-item {
  margin-left: 78px;
}
.surgic-star .ss-legend-item h6 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 19px;
  font-weight: 700;
}
.surgic-star .ss-legend-item p {
  margin-top: 4px;
  font-size: 16px;
  color: var(--c-grey);
  line-height: 1.4;
}

.surgic-star .ss-two-col {
  display: flex;
  width: 1180px;
  margin: 200px auto 0 auto;
}
.surgic-star .ss-two-col .ss-col p {
  font-size: 19px;
  margin-top: 22px;
}
.surgic-star .ss-col {
}
.surgic-star .ss-col + .ss-col {
  margin-left: 90px;
}
.surgic-star .ss-col h5 {
  font-size: 50px;
  font-weight: 700;
}
.surgic-star .ss-col .p-grey {
  margin-top: 12px;
}
.surgic-star .ss-col .p-orange {
  margin-top: 4px;
}
.surgic-star .ss-col .ss-card-img {
  margin-top: 40px;
}

.surgic-star .ss-col .ss-card-img img {
  display: block;
  width: 536px;
}

/* ============ 7. 7英寸界面 ============ */
.surgic-star .ss-screen-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.surgic-star .ss-screen-banner .ss-screen-banner-img {
  width: 100%;
}
.surgic-star .ss-screen-banner .ss-screen-banner-img img {
  width: 100%;
  display: block;
}
.surgic-star .ss-screen-banner .ss-screen-banner-text {
  position: absolute;
  left: 360px;          /* design 443 / K */
  top: 106px;
  width: 620px;
}
.surgic-star .ss-screen-banner .ss-screen-banner-text h5 {
  font-size: 42px;      /* design ink 621 宽 -> Demibold 42 */
  font-weight: bold;
  color: #000000;
  line-height: 1.05;
  white-space: nowrap;
}
.surgic-star .ss-screen-banner .ss-screen-banner-text h5 .t-orange {
  color: #ff7033;
}
.surgic-star .ss-screen-banner .ss-screen-banner-text > p {
  margin-top: 38px;
  font-size: 18px;
  color: #5e5d5b;
  line-height: 27.9px;   /* 设计行距 33 / K */
  white-space: nowrap;
}

/* ============ 8. Bicolor Smart Interface ============ */
.surgic-star .ss-dual-theme {
  position: relative;
  width: 100%;
  height: 740px;
  overflow: hidden;
}
.surgic-star .ss-dual-theme .ss-center-title {
  position: absolute;
  left: 0;
  top: 150px;
  width: 100%;
  margin-top: 0;
  text-align: center;
}
.surgic-star .ss-dual-theme .ss-center-title h5 {
  font-size: 42px;       /* design ink 566 宽 -> Demibold 42 */
  font-weight: bold;
  line-height: 1.0;
}
.surgic-star .ss-dual-theme .ss-center-title p {
  margin-top: 32px;
  color: var(--c-grey);
  font-size: 18px;       /* 墨迹宽 274 宽 -> Normal 18 */
  line-height: 27.9px;   /* 设计行距 33 / K */
}
.surgic-star .ss-theme-list {
  position: absolute;
  left: 0;
  top: 335px;
  width: 100%;
}
.surgic-star .ss-theme-item {
  position: absolute;
  width: 533px;
  text-align: center;
}
.surgic-star .ss-theme-item:nth-child(1) {
  left: 394px;
}
.surgic-star .ss-theme-item:nth-child(2) {
  left: 992px;
}
.surgic-star .ss-theme-item img {
  width: 533px;
  display: block;
}
.surgic-star .ss-theme-item p {
  margin-top: 27px;
  font-size: 15px;
  line-height: 22.5px;
  color: #000000;
}

/* ============ 9. 双水路 / 10. 无线脚踏 / 11. 推车 ============ */
.surgic-star .ss-water {
  position: relative;
  width: 100%;
  height: 998px;
  overflow: hidden;
}
.surgic-star .ss-water .ss-water-img {
  position: absolute;
  left: 0;
  right: 0;
  top: 305px;            /* design 21707 - 21347 = 360 / K */
  width: 1134px;         /* design 1340 / K */
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
}
.surgic-star .ss-foot {
  position: relative;
  z-index: 2;            /* 设计稿：脚踏在下方购物车大图（4.jpg 顶部为白色渐变）之上 */
  width: 100%;
  height: 1030px;
  overflow: hidden;
}


/* ============ 12. 参数（实测量取，逐行绝对定位） ============ */
.surgic-star .ss-cart .ss-specs {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.surgic-star .ss-cart .ss-specs-col {
  position: absolute;
  top: 0;
}
.surgic-star .ss-cart .ss-specs-left {
  left: 392.8px;          /* design 464 / K */
}
.surgic-star .ss-cart .ss-specs-right {
  left: 872.4px;          /* design 1030.5 / K */
}
.surgic-star .ss-cart .ss-spec-line {
  position: absolute;
  left: 0;
  margin: 0;
  color: #ffffff;
  font-size: 16.45px;     /* 行宽 438 设计 px / K */
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
}
.surgic-star .ss-cart .ss-spec-line .ss-specs-label {
  margin-right: 9px;      /* 标签与值的墨迹间隙 13 设计 px / K */
  letter-spacing: 0.3px;  /* 设计稿标签比 MiSans-Normal 略宽 3.5% */
}
.surgic-star .ss-cart .ss-specs-left .ss-spec-line:nth-child(1) { top: 1269.0px; }
.surgic-star .ss-cart .ss-specs-left .ss-spec-line:nth-child(2) { top: 1316.4px; }
.surgic-star .ss-cart .ss-specs-left .ss-spec-line:nth-child(3) { top: 1363.0px; }
.surgic-star .ss-cart .ss-specs-left .ss-spec-line:nth-child(4) { top: 1409.5px; }
.surgic-star .ss-cart .ss-specs-left .ss-spec-line:nth-child(5) { top: 1455.2px; }
.surgic-star .ss-cart .ss-specs-left .ss-spec-line:nth-child(6) { top: 1498.4px; }
.surgic-star .ss-cart .ss-specs-right .ss-spec-line:nth-child(1) { top: 1316.4px; }
.surgic-star .ss-cart .ss-specs-right .ss-spec-line:nth-child(2) { top: 1363.0px; }
.surgic-star .ss-cart .ss-specs-right .ss-spec-line:nth-child(3) { top: 1409.5px; }
.surgic-star .ss-cart .ss-specs-right .ss-spec-line:nth-child(4) { top: 1455.2px; }
.surgic-star .ss-cart .ss-specs-right .ss-spec-line:nth-child(5) { top: 1498.4px; }

.surgic-star .ss-bone .enhance p {
  color: var(--c-grey);
  margin-top: 16px;
}

.surgic-star .ss-bone .enhance .number {
  color: var(--c-orange);
}

.surgic-star .micro-power {
  padding-bottom: 235px;
  background: linear-gradient(to bottom, #ffffff 50%, #f5f5f7 100%);
}
.surgic-star .micro-power .ss-section-head .ss-qr {
  top: 10px;
}

.surgic-star .micro-power .ss-wide-img {
  margin-top: -110px;
}

.surgic-star .micro-power .ss-tags {
  margin-top: -90px;
}

/* ============ Triple Spray / German Bearings（1:1 实测 2268 设计稿） ============ */
.surgic-star .ss-cool {
  position: relative;
  height: 1888.03px;
  margin-top: 108.5px;
  background: linear-gradient(180deg, #fdfdfd 0%, #f5f5f7 45%, #f5f5f7 100%);
}
.surgic-star .ss-cool .ss-cool-img {
  position: absolute;
  left: 375.03px;
  top: 40.64px;
  width: 1173.33px;
  height: 649.31px;
}
.surgic-star .ss-cool .ss-cool-text {
  position: absolute;
  left: 1122.56px;
  top: 316.7px;
}
.surgic-star .ss-cool .ss-cool-text h5 {
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: normal;
  font-size: 36.1px;
  line-height: 46.98px;
  color: #000;
}
.surgic-star .ss-cool .ss-cool-text ul {
  list-style: none;
  margin: 23.4px 0 0 0;
  padding: 0;
}
.surgic-star .ss-cool .ss-cool-text li {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.2px;
  line-height: 28.19px;
  color: #666;
}
.surgic-star .ss-cool .ss-bearing-title {
  position: absolute;
  left: 0;
  right: 0;
  top: 877.6px;
  text-align: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: normal;
  font-size: 43.15px;
  line-height: 1;
  color: #000;
}
.surgic-star .ss-cool .ss-bearing-sub {
  position: absolute;
  left: 0;
  right: 0;
  top: 957.7px;
  text-align: center;
}
.surgic-star .ss-cool .ss-bearing-sub p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.2px;
  line-height: 28.19px;
  color: #666;
}
.surgic-star .ss-cool .ss-ratio {
  position: absolute;
  left: 0;
  right: 0;
  top: 1054.8px;
}
.surgic-star .ss-cool .ss-ratio img {
  display: block;
  margin: 0 auto;
  width: 350.48px;
  height: auto;
}
.surgic-star .ss-cool .ss-bearing-img {
  position: absolute;
  left: 0;
  top: 925.5px;
  width: 1920px;
  height: 577.3px;
}
.surgic-star .ss-cool .ss-chart-cap {
  position: absolute;
  left: 597.67px;
  top: 1469.9px;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 15.33px;
  line-height: 1;
  color: #595959;
}
.surgic-star .ss-cool .ss-chart-plot {
  position: absolute;
  left: 575.61px;
  top: 1490.79px;
  width: 794px;
  height: 159.15px;
}
.surgic-star .ss-cool .ss-chart-x {
  position: absolute;
  left: 0;
  top: 1655.7px;
  width: 1920px;
}
.surgic-star .ss-cool .ss-chart-x > div {
  position: absolute;
  transform: translateX(-50%);
  text-align: center;
}
.surgic-star .ss-cool .ss-chart-x > div:nth-child(1) {
  left: 736.9px;
}
.surgic-star .ss-cool .ss-chart-x > div:nth-child(2) {
  left: 968px;
}
.surgic-star .ss-cool .ss-chart-x > div:nth-child(3) {
  left: 1198.1px;
}
.surgic-star .ss-cool .ss-chart-x p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 17.4px;
  line-height: 22px;
  color: #595959;
  text-align: left;
}
.surgic-star .ss-cool .ss-chart-legend {
  position: absolute;
  left: 0;
  top: 1741.6px;
  width: 1920px;
}
.surgic-star .ss-cool .ss-chart-legend span {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
}
.surgic-star .ss-cool .ss-chart-legend .lg-surgic {
  left: 745.8px;
  color: #41a4d2;
}
.surgic-star .ss-cool .ss-chart-legend .lg-a {
  left: 927.8px;
  color: #dd8f1d;
}
.surgic-star .ss-cool .ss-chart-legend .lg-b {
  left: 1085.2px;
  color: #d9b57e;
}
.surgic-star .ss-cool .ss-chart-legend i {
  display: block;
  width: 11.85px;
  height: 11.85px;
  margin-right: 12.75px;
}
.surgic-star .ss-cool .ss-chart-legend .lg-a i {
  background: #dd8f1d;
}
.surgic-star .ss-cool .ss-chart-legend .lg-b i {
  background: #d9b57e;
}

.surgic-star .ss-implant .ss-section-head {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 470px;
  text-align: left;
}
.surgic-star .ss-implant .ss-qr {
  position: absolute;
  left: 372px;
  top: 159px;
  width: 91px;
  text-align: center;
}
.surgic-star .ss-implant .ss-qr img {
  display: block;
  width: 100%;
  margin: 0;
}
.surgic-star .ss-implant .ss-qr p {
  font-size: 10px;
  margin-top: 4px;
  text-align: center;
  color: var(--c-grey);
  line-height: 1.4;
  white-space: nowrap;
}
.surgic-star .ss-implant .ss-implant-logo {
  position: absolute;
  left: 864px;
  top: 159px;
  width: 191px;
}
.surgic-star .ss-implant .ss-implant-logo img {
  display: block;
  width: 100%;
}
.surgic-star .ss-implant .ss-section-title.planting {
  position: absolute;
  left: 372px;
  top: 165px;
  width: 160px;
  margin: 0;
  align-items: flex-start;
}
.surgic-star .ss-implant .ss-section-title.planting .ss-num,
.surgic-star .ss-implant .ss-section-title.planting .ss-name {
  color: #1f7a7f;
  font-family: 'MiSans-Demibold', sans-serif;
}
.surgic-star .ss-implant .ss-section-title.planting .ss-num {
  font-size: 128px;
  line-height: 1;
  letter-spacing: -3px;
}
.surgic-star .ss-implant .ss-section-title.planting .ss-name {
  font-size: 42px;
  margin-top: 6px;
}
.surgic-star .ss-section-title.planting img {
  display: block;

}

.surgic-star .ss-implant {
  position: relative;
  background: linear-gradient(to bottom, #ffffff 50%, #f5f5f7 100%);
  height: 4386px;
  overflow: hidden;
}
.surgic-star .ss-implant .ss-wide-img {
  position: absolute;
  top: 322px;
  left: 0;
  width: 100%;
}
.surgic-star .ss-implant .ss-wide-img img {
  display: block;
  width: 100%;
}

.surgic-star .ss-implant .preset {
  position: absolute;
  top: 850px;
  left: 0;
  width: 100%;
}
.surgic-star .ss-implant .preset .ss-center-title {
  position: absolute;
  left: 0;
  top: -15px;
  width: 100%;
  margin: 0;
  text-align: center;
}
.surgic-star .ss-implant .preset .ss-center-title h5 {
  font-size: 42px;
}
.surgic-star .ss-implant .preset .ss-program-list {
  position: absolute;
  left: 369px;
  top: 86px;
  width: 1181px;
  margin: 0;
}
.surgic-star .ss-implant .preset .ss-program-list img {
  display: block;
  width: 100%;
}
.surgic-star .ss-implant .preset .ss-program-list p {
  position: absolute;
  top: 148px;
  transform: translateX(-50%);
  font-size: 15px;
  color: var(--c-dark);
  white-space: nowrap;
}
.surgic-star .ss-implant .preset .ss-program-list p:nth-child(2){ left: 112px; }
.surgic-star .ss-implant .preset .ss-program-list p:nth-child(3){ left: 351px; }
.surgic-star .ss-implant .preset .ss-program-list p:nth-child(4){ left: 590px; }
.surgic-star .ss-implant .preset .ss-program-list p:nth-child(5){ left: 831px; }
.surgic-star .ss-implant .preset .ss-program-list p:nth-child(6){ left: 1071px; }

.surgic-star .ss-implant .ss-detail.parallel {
  position: absolute;
  top: 1281px;          /* design 15840 - 14327 = 1513 / 1.18125 */
  left: 0;
  width: 100%;
  margin: 0;
}
.surgic-star .ss-implant .parallel {
  display: block;
  margin: 0;
}

.surgic-star .ss-implant .parallel .ss-detail-text {
  position: absolute;
  left: 365px;          /* design 439 / K */
  top: 102px;
  width: 520px;
  padding-top: 0;
}

.surgic-star .ss-implant .parallel .ss-detail-text h5 {
  font-size: 35px;      /* 实测字宽匹配 design 461 */
  line-height: 46.5px;  /* 行间距 55 design = 46.6px */
  color: #000000;
}
.surgic-star .ss-implant .parallel .ss-detail-text p {
  font-size: 16.5px;
  color: #666666;
  line-height: 25.4px;  /* 行间距 30 design = 25.4px */
  margin-top: 0;
  white-space: nowrap;
}
.surgic-star .ss-implant .parallel .ss-detail-text p:nth-child(2) {
  margin-top: 83px;
  line-height: 25.4px;
}


.surgic-star .ss-implant .parallel .ss-card-img {
  position: absolute;
  left: 942px;          /* design 1113 / K */
  top: 0;
  width: 606px;         /* design 716 / K */
  height: 497px;        /* design 587 / K */
  margin: 0;
  border-radius: 23px;  /* design 27 / K */
  overflow: hidden;
  background: #f5f5f5;
}
.surgic-star .ss-implant .parallel .ss-card-img img {
  display: block;
  width: 683px;         /* design 807 / K (原图 1:1，超出卡片左侧被裁切) */
  max-width: none;
  margin-left: -77px;   /* design (1022.5-1113) / K */
}

.surgic-star .ss-implant .collocation {
  position: absolute;
  top: 3151px;
  left: 0;
  width: 100%;
  margin: 0;
}
.surgic-star .ss-implant .collocation .g-t-txt {
  position: absolute;
  left: 369px;
  top: 0;
  width: 1089px;
  text-align: left;
}
.surgic-star .ss-implant .collocation .g-t-txt p:nth-child(1) {
  font-size: 18.2px;
  color: #646464;       /* 设计灰字（--c-grey #7d7d7d 偏浅） */
  text-indent: -0.85px; /* 亚像素左移，对齐设计 ink 左缘 */
}
.surgic-star .ss-implant .collocation .g-t-txt .ss-ratio2 {
  display: block;
  width: 376.72px;      /* design 445 / K */
  height: auto;
  margin-top: 21.44px;
}
.surgic-star .ss-implant .collocation .ss-two-col {
  position: absolute;
  left: 0;
  top: 331px;
  width: 100%;
  height: 0;
  margin: 0;
}
.surgic-star .ss-implant .collocation .ss-col {
  position: absolute;
  width: 552px;
  height: 646px;
}
.surgic-star .ss-implant .collocation .ss-col:nth-child(1) {
  left: 372px;
  top: 0;
}
.surgic-star .ss-implant .collocation .ss-col:nth-child(2) {
  left: 996px;
  top: 0;
  margin-left: 0;
}
.surgic-star .ss-implant .collocation .ss-col h5 {
  text-align: left;
  font-size: 42px;      /* design ink 54 高 */
  line-height: 1.2;
  color: var(--c-dark);
  white-space: nowrap;
}
.surgic-star .ss-implant .collocation .ss-col p {
  text-align: left;
  color: var(--c-grey);
  font-size: 18px;
  line-height: 27.9px;  /* 设计行距 33 / K */
  margin-top: 26px;
}
.surgic-star .ss-implant .collocation .ss-col .ss-card-img {
  position: absolute;
  left: 0;
  top: 162px;           /* design 18633 - collocation top */
  width: 552px;         /* 素材 652 x 578 为 1:1 设计尺寸 */
  margin: 0;
}
.surgic-star .ss-implant .collocation .ss-col .ss-card-img img {
  display: block;
  width: 100%;
}

/* torque card */
.surgic-star .ss-implant .ss-torque-card {
  position: absolute;
  top: 1947px;          /* design 16627 - 14327 = 2300 / K */
  left: 0;
  width: 100%;
  height: 494px;
  display: block;
  margin: 0;
  border-radius: 0;
  overflow: visible;
}
.surgic-star .ss-implant .ss-torque-visual {
  position: absolute;
  left: 372px;          /* design 440 / K */
  top: 0;
  width: 678px;         /* design 801 / K */
  margin: 0;
}
.surgic-star .ss-implant .ss-torque-visual img {
  display: block;
  width: 100%;
}
.surgic-star .ss-implant .ss-torque-info {
  position: absolute;
  left: 1116px;         /* design 1319 / K */
  top: 0;
  width: 433px;
  height: 494px;
  margin: 0;
}
/* 一行三个元素：按设计稿各自绝对定位，底部基线对齐 y16858 */
.surgic-star .ss-implant .ss-torque-info .ss-torque-row {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  font-size: 22px;
  color: #666666;
}
.surgic-star .ss-implant .ss-torque-info .ss-torque-row span {
  position: absolute;
  font-size: 21px !important;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}
.surgic-star .ss-implant .ss-torque-info .ss-torque-row span:nth-child(1) {
  left: 0;
  top: 172px;           /* design 16833 -> 2121.5 */
}
.surgic-star .ss-implant .ss-torque-info .ss-torque-row span:nth-child(3) {
  left: 362px;          /* design 1746 -> 362 */
  top: 175px;           /* design 16836 -> 2124.0 */
}
.surgic-star .ss-implant .ss-torque-info .ss-torque-row .ss-torque-value {
  position: absolute;
  left: 185px;          /* design 1537 -> 185 */
  top: 152px;           /* design 16812 -> 2104.0 */
  font-size: 50px !important;
  line-height: 1;
  color: #000000;
}
.surgic-star .ss-implant .ss-torque-info .ss-slider {
  position: absolute;
  left: 0;
  top: 213px;           /* design 16879 -> 213.3 */
  width: 433px;         /* design 512 / K */
  height: 12px;
  margin: 0;
  border-radius: 6px;
  overflow: hidden;
}
.surgic-star .ss-implant .ss-torque-info .ss-slider-track {
  background-color: #494b57;
}
.surgic-star .ss-implant .ss-torque-info .ss-slider .ss-slider-fill {
  height: 100%;
  border-radius: 6px;
}
.surgic-star .ss-implant .ss-torque-info .ss-slider .ss-slider-fill-cyan {
  background: linear-gradient(90deg, #69d5e2 0%, #46b4ef 55%, #2397fe 100%);
}
.surgic-star .ss-implant .ss-torque-info > .p-grey {
  position: absolute;
  left: 0;
  top: 254px;           /* design 16930 -> 256.5 */
  margin: 0;
  font-size: 18px;
  line-height: 1.2;
  color: #666666;
}
.surgic-star .ss-implant .ss-torque-info .ss-big-orange {
  position: absolute;
  left: 1px;
  top: 298px;           /* design 16982 -> 2247.8 */
  margin: 0;
  font-size: 52px !important;
  line-height: 1;
  font-weight: 700;
  color: var(--c-orange);
}
/* torque hold */
.surgic-star .ss-implant .ss-torque-hold {
  position: absolute;
  top: 2640px;
  left: 0;
  width: 100%;
  margin: 0;
  text-align: left;
}
.surgic-star .ss-implant .ss-torque-hold h5 {
  position: absolute;
  left: 370px;          /* design 438 / K */
  top: -8px;            /* design 17439 */
  width: 600px;
  font-size: 42px;      /* design ink 599x54 */
  font-weight: 700;
  line-height: 1;
  text-align: left;
  white-space: nowrap;
}
.surgic-star .ss-implant .ss-torque-hold > .p-grey {
  position: absolute;
  left: 371px;          /* design 440 / K */
  top: 68px;            /* design 17534 */
  width: 830px;
  margin-top: 0;
  font-size: 16px;
  color: var(--c-grey);
  line-height: 27.9px;  /* 设计行距 33 / K */
  white-space: nowrap;
}
.surgic-star .ss-implant .ss-torque-hold .ss-chart-note {
  position: absolute;
  left: 461px;          /* design 545 / K */
  top: 260.3px;         /* design 17751 */
  width: 160px;
  font-size: 13px;
  line-height: 15px;    /* 设计行距 18 / K */
  color: #4a4a4a;      /* 设计灰字 */
  white-space: nowrap;
}
.surgic-star .ss-implant .ss-torque-hold .ss-hold-chart {
  position: absolute;
  left: 357.85px;       /* design 422 / K（+0.85 亚像素对齐） */
  top: 174px;           /* design 17650 */
  width: 578px;         /* design 683 / K（素材 1366 为 2x） */
  margin: 0;
}
.surgic-star .ss-implant .ss-torque-hold .ss-hold-chart img {
  display: block;
  width: 100%;
}
.surgic-star .ss-implant .ss-torque-hold .ss-hold-legend {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 0;
  margin: 0;
}
.surgic-star .ss-implant .ss-torque-hold .ss-legend-item {
  position: absolute;
  margin: 0;
}
.surgic-star .ss-implant .ss-torque-hold .ss-legend-item:nth-child(1) {
  left: 1016px;         /* design 1201 / K */
  top: 220px;           /* design 17708 */
  width: 245px;         /* design 272 / K */
}
.surgic-star .ss-implant .ss-torque-hold .ss-legend-item:nth-child(2) {
  left: 1314px;         /* design 1552 / K */
  top: 222px;           /* design 17710 */
  width: 310px;         /* design 353 / K */
}
.surgic-star .ss-implant .ss-torque-hold .ss-legend-item h6 {
  margin: 0;
  font-size: 15.28px;
  font-weight: 700;
  line-height: 20px;
}
.surgic-star .ss-implant .ss-torque-hold .ss-legend-item p {
  margin: 0;
  font-size: 16.34px;
  line-height: 23.3px;  /* 设计行距 27.5 / K */
  color: #646464;       /* 设计灰字（--c-grey #7d7d7d 偏浅） */
  white-space: nowrap;
  margin-top: 5px;
}


.surgic-star .ss-water .ss-center-title {
  position: absolute;
  left: 0;
  top: 117px;
  width: 100%;
  margin-top: 0;
  text-align: center;
}
.surgic-star .ss-water .ss-center-title h5 {
  font-size: 41.5px;     /* design ink 724 宽 / K = 612.9 -> Demibold 41.5 */
  font-weight: 700;
  line-height: 1.0;
}
.surgic-star .ss-water .ss-center-title p {
  margin-top: 35px;
  color: var(--c-grey);
  font-size: 18.2px;
  line-height: 27.9px;   /* 设计行距 33 / K */
}


.surgic-star .ss-foot .ss-center-title {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  margin-top: 0;
  text-align: center;
}
.surgic-star .ss-foot .ss-center-title h5 {
  font-size: 41.5px;     /* design ink 485 宽 / K = 410.6 -> Demibold 41.5 */
  font-weight: 700;
  line-height: 1.0;
}
.surgic-star .ss-foot .ss-center-title p {
  margin-top: 30px;
  color: var(--c-grey);
  font-size: 18.2px;
  line-height: 27.9px;   /* 设计行距 33 / K */
}
.surgic-star .ss-foot .ss-foot-img {
  position: absolute;
  left: 565px;           /* design 668 / K */
  top: 168px;
  width: 989px;          /* design 1169 / K（素材原生 1:1） */
}
.surgic-star .ss-foot .ss-foot-img img {
  display: block;
  width: 100%;
}

.surgic-star .ss-cart {
  position: relative;
  z-index: 1;
  margin-top: -421.3px;   /* 4.jpg 顶边 = 设计 23245，比上一段底部（23742.7）高 497.7 设计 px */
}
.surgic-star .ss-cart .ss-cart-img img {
  display: block;
  width: 100%;
  height: auto;
}
.surgic-star .ss-cart .ss-center-title {
  position: absolute;
  left: 0;
  top: 371.7px;           /* 标题墨迹 设计 23686 - 23245 = 441 / K */
  width: 100%;
  margin-top: 0;
  text-align: center;
}
.surgic-star .ss-cart .ss-center-title h5 {
  font-size: 41.7px;      /* design ink 712 宽 / K = 602.8 */
  font-weight: 700;
  line-height: 1.0;
  letter-spacing: 0;
}
.surgic-star .ss-cart .ss-center-title p {
  margin-top: 35.3px;
  color: #333333;
  font-size: 18.2px;
  line-height: 28.4px;    /* 设计行距 34 / K */
}

/* ---- EN-specific overrides (design 2268px vs CN 1920px) ---- */
/* QR block: 110×110 design px, caption 11.5px, centred on the code. */
.surgic-star .ss-section-head .ss-qr {
  width: 93px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.surgic-star .ss-section-head .ss-qr p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 11.5px;
  line-height: 11.5px;
  color: #666666;
  margin: 7.5px 0 0 0;
  white-space: nowrap;
}

/* ================= 01 PIEZOSURGERY chapter head (measured 1:1) =================
   design 2268 → CSS = design / 1.18125
   logo top 3800 (182 after modes image), QR 110 at x438 y3807,
   handpiece full-bleed at y3998, pills 314×164 at y4495. */
.surgic-star .ss-bone {
  padding-top: 0;
  background: linear-gradient(to bottom, #ffffff 50%, #f5f5f7 100%);
}
.surgic-star .ss-bone .ss-section-head {
  padding-top: 154px;
}
/* logotype (numeral + wordmark + rule) sits ~4 design px right of centre in the design */
.surgic-star .ss-bone .ss-section-title.ss-section-title-img {
  display: block;
  width: 323px;
  margin: 0 auto;
  position: relative;
  left: 3px;
}
.surgic-star .ss-bone .ss-section-head .ss-qr {
  left: 371px;
  top: 160px;
}
.surgic-star .ss-bone .ss-wide-img.gudao {
  display: block;
  padding-bottom: 0;
}
.surgic-star .ss-bone .ss-wide-img.gudao img {
  position: static;
  top: auto;
  width: 100%;
  margin-top: -89px;
}
/* four tags as light pills (no icons in the EN design) */
.surgic-star .ss-bone .ss-tags {
  margin-top: -95px;
  gap: 37px;
}
.surgic-star .ss-bone .ss-tags div {
  width: 265.8px;
  height: 166.8px;
  margin-left: 0;
  border-radius: 23.7px;
  padding-top: 48px;
  background: linear-gradient(180deg, #fdfdfd 0%, #f5f5f5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.surgic-star .ss-bone .ss-tags h5 {
  position: static;
  transform: none;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 21.7px;
  font-weight: normal;
  line-height: 1;
  color: #303030;
  white-space: nowrap;
}

/* ===== 01 PIEZOSURGERY · detail + power + efficiency (1:1 measured 2268) =====
   design y: heading 4864 / params 5061 / image 5188-5799 / power 6031
   handpiece box 6137 / efficiency 6825-7157.
   CSS px = design / 1.18125 */
.surgic-star .ss-bone .ss-detail {
  width: 100%;
  margin: 0;
  padding-top: 165px;
}
.surgic-star .ss-bone .ss-detail-text {
  padding-top: 0;
  padding-left: 372px;
}
.surgic-star .ss-bone .ss-detail-text h5 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 41.6px;
  font-weight: normal;
  line-height: 55.9px;
  color: #000;
}
.surgic-star .ss-bone .ss-params {
  margin-top: 62px;
  align-items: flex-start;
}
.surgic-star .ss-bone .ss-params .ss-param {
  width: 462px;
}
.surgic-star .ss-bone .ss-param + .ss-param {
  margin-left: 0;
}
.surgic-star .ss-bone .ss-params .ss-param .p-orange {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 23.5px;
  line-height: 1;
  font-weight: normal;
  color: #fc6e2d;
  white-space: nowrap;
}
.surgic-star .ss-bone .ss-params .ss-param .p-grey {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 20px;
  line-height: 1;
  color: #666;
  margin-top: 30.5px;
  white-space: nowrap;
}
.surgic-star .ss-bone .ss-detail-img {
  width: 1177px;
  height: 517px;
  margin: 37px auto 0 auto;
  border-radius: 31px;
}
.surgic-star .ss-bone .ss-detail-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* --- centered "10 Adjustable Power Levels" --- */
.surgic-star .ss-bone .ss-center-title.power {
  margin-top: 185.6px;
}
.surgic-star .ss-bone .ss-center-title.power h5 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 41.6px;
  font-weight: normal;
  line-height: 55.9px;
  color: #000;
}
.surgic-star .ss-bone .ss-center-title.power h5 .t-orange {
  color: #fc6e2d;
}
.surgic-star .ss-bone .ss-center-title.power p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.15px;
  line-height: 27.9px;
  color: #666;
  margin-top: 31px;
}

/* --- full-bleed silver handpiece --- */
.surgic-star .ss-bone .ss-wide-img.shoubin {
  margin-top: -88px;
}
.surgic-star .ss-bone .ss-wide-img.shoubin img {
  display: block;
  width: 100%;
  margin-top: 0;
}

/* --- efficiency comparison (left text + two charts) --- */
.surgic-star .ss-bone .ss-efficiency {
  position: relative;
  display: block;
  margin: -143px 0 0 0;
  height: 292px;
}
.surgic-star .ss-bone .ss-efficiency-left {
  position: absolute;
  left: 555px;
  top: 8.45px;
}
.surgic-star .ss-bone .ss-efficiency h5 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 27.9px;
  font-weight: normal;
  line-height: 37.2px;
  color: #000;
  white-space: nowrap;
}
.surgic-star .ss-bone .ss-efficiency h5 .t-orange {
  color: #fc6e2d;
}
.surgic-star .ss-bone .ss-efficiency .sub {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 17.28px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 27.9px;
  color: #000;
  margin-top: 6.1px;
  white-space: nowrap;
}
.surgic-star .ss-bone .ss-bar-row {
  position: static;
}
.surgic-star .ss-bone .ss-bar {
  display: block;
  height: 12.7px;
  margin-top: 0;
  background: #fc6e2d;
}
.surgic-star .ss-bone .ss-bar-a {
  width: 170px;
}
.surgic-star .ss-bone .ss-bar-b {
  width: 281px;
}
.surgic-star .ss-bone .ss-bar-label {
  display: block;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.15px;
  line-height: 1;
  color: #666;
  margin-top: 12.05px;
}
.surgic-star .ss-bone .ss-bar-row + .ss-bar-row {
  margin-top: 19.65px;
}
.surgic-star .ss-bone .ss-bar-row + .ss-bar-row .ss-bar-label {
  margin-top: 17.1px;
}
.surgic-star .ss-bone .ss-bars {
  margin-top: 40.75px;
}
.surgic-star .ss-bone .ss-two-modes {
  display: block;
}
.surgic-star .ss-bone .ss-two-mode {
  position: absolute;
  top: 24.6px;
  margin: 0;
}
.surgic-star .ss-bone .ss-two-mode:nth-child(1) {
  left: 1070px;
}
.surgic-star .ss-bone .ss-two-mode:nth-child(2) {
  left: 1323px;
}
.surgic-star .ss-bone .ss-two-mode .ss-two-mode-img {
  width: 157px;
}
.surgic-star .ss-bone .ss-two-mode:nth-child(2) .ss-two-mode-img {
  width: 146.45px;
}
.surgic-star .ss-bone .ss-two-mode .ss-two-mode-img img {
  width: 100%;
  height: auto;
  display: block;
}
.surgic-star .ss-bone .ss-two-mode h6 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 27.8px;
  font-weight: normal;
  line-height: 1;
  color: #303030;
  margin-top: 25px;
}
.surgic-star .ss-bone .ss-two-mode p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.4px;
  line-height: 28.2px;
  color: #666;
  margin-top: 16.45px;
  white-space: nowrap;
}

/* ---------- Boost 25% + 屏幕 + 02 SURGICAL ---------- */
/* 设计真值(2268)：Boost 墨迹 y7359-7400 / 25% y7449-7566 x988-1280 /
   instant y7584-7608 / 屏幕图 x0-2268 y7578-8163 /
   QR x438-548 y8319-8429 / 标识 x1010 y8316 w254 / 手柄 x0 y8560 */
.surgic-star .ss-bone .enhance {
  margin-top: 169px;
}
.surgic-star .ss-bone .enhance h5 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 42.5px;
  font-weight: normal;
  line-height: 1;
  color: #000;
}
.surgic-star .ss-bone .enhance .number {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 121px;
  line-height: 1;
  color: #fc6e2d;
  margin-top: 28px !important;
}
.surgic-star .ss-bone .enhance .sub {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 20.4px;
  line-height: 1;
  color: #4d4d4d;
  margin-top: 2px;
}
.surgic-star .ss-bone .ss-screen-img {
  margin-top: -24px;
}
.surgic-star .ss-bone .ss-screen-img img {
  display: block;
  width: 100%;
}

.surgic-star .ss-surgical {
  padding-top: 0;
  padding-bottom: 0;
}
.surgic-star .ss-surgical .ss-section-head {
  height: 0;
}
.surgic-star .ss-surgical .ss-section-head .ss-qr {
  left: 370px;
  top: 132px;
  width: 93px;
}
.surgic-star .ss-surgical .ss-section-head .ss-qr img {
  display: block;
  width: 100%;
}
.surgic-star .ss-surgical .ss-section-head .ss-qr p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 10px;
  line-height: 1;
  color: #666;
  margin-top: 9px;
  white-space: nowrap;
}
.surgic-star .ss-surgical .ss-section-title.surgical {
  position: absolute;
  left: 855px;
  top: 129px;
  width: 215px;
  margin-top: 0;
}
.surgic-star .ss-surgical .ss-section-title.surgical img {
  display: block;
  width: 100%;
}
.surgic-star .ss-surgical .ss-wide-img.surgical-handle {
  padding-top: 336px;
  margin-top: 0;
}
.surgic-star .ss-surgical .ss-wide-img.surgical-handle img {
  display: block;
  width: 100%;
}

/* ===== 02 SURGICAL · four pills + brown banner (1:1 measured 2268) =====
   design: cards y9042-9239 / x439,797,1155,1513 w314 gap44
           banner y9385-10292 (3.jpg 2268x907)
           text left x436; h5#1 ink top y9565; p1 y9644/9682; h5#2 y9770; p2 y9849/9887
   CSS px = design / 1.18125 */
.surgic-star .ss-surgical .ss-tags {
  display: flex;
  justify-content: flex-start;
  padding-left: 372.1px;
  gap: 37.25px;
  margin-top: -78px;
}
.surgic-star .ss-surgical .ss-tags div {
  width: 265.8px;
  height: 166.8px;
  margin-left: 0;
  border-radius: 23.7px;
  padding-top: 48px;
  background: linear-gradient(180deg, #fdfdfd 0%, #f5f5f5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.surgic-star .ss-surgical .ss-tags h5 {
  position: static;
  transform: none;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 21.5px;
  font-weight: normal;
  line-height: 1;
  color: #303030;
  white-space: nowrap;
}
.surgic-star .ss-surgical .ss-dark-img {
  margin-top: 124px;
}
.surgic-star .ss-surgical .ss-dark-img img {
  display: block;
  width: 100%;
}
.surgic-star .ss-surgical .ss-dark-banner .ss-dark-text {
  left: 369px;
  top: 147.3px;
}
.surgic-star .ss-surgical .ss-dark-banner .ss-dark-item h5 {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 43.1px;
  font-weight: normal;
  line-height: 1.15;
  color: #fff;
}
.surgic-star .ss-surgical .ss-dark-banner .ss-dark-item p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.2px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.92);
  margin-top: 16.2px;
}
.surgic-star .ss-surgical .ss-dark-banner .ss-dark-item + .ss-dark-item {
  margin-top: 50.5px;
}

/* ===== 电机参数区 High-Performance Brushless Motor ===== */
.surgic-star .ss-surgical .ss-motor-figure .ss-center-title {
  margin-top: 131.4px;
}
.surgic-star .ss-surgical .ss-motor-figure .ss-center-title h5 {
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: normal;
  font-size: 43.18px;
  line-height: 1.25;
  color: #000;
}
.surgic-star .ss-surgical .ss-motor-figure .ss-center-title p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 17.9px;
  line-height: 27.9px;
  color: #636363;
  margin-top: 14.9px;
}
.surgic-star .ss-surgical .ss-motor-figure .ss-center-title p + p {
  margin-top: 0;
}
.surgic-star .ss-surgical .ss-motor-img {
  position: relative;
  width: 765.3px;
  height: 877.1px;
  margin: 78.9px auto 0 auto;
  left: 6.8px;
}
.surgic-star .ss-surgical .ss-motor-img > img {
  display: block;
  width: 765.3px;
  height: 877.1px;
}
.surgic-star .ss-surgical .ss-motor-params .ss-param {
  position: absolute;
  top: 380.8px;
  margin-left: 0;
  text-align: left;
}
.surgic-star .ss-surgical .ss-motor-params .ss-param:nth-child(1) {
  left: auto;
  right: 599.4px;
  top: 380.8px;
  text-align: right;
}
.surgic-star .ss-surgical .ss-motor-params .ss-param:nth-child(2) {
  left: 607px;
  right: auto;
  top: 380.8px;
  margin-left: 0;
}
.surgic-star .ss-surgical .ss-motor-params .ss-param .ss-big-orange {
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: normal;
  font-size: 53.8px !important;
  line-height: 1;
  color: #ff7033;
  white-space: nowrap;
}
.surgic-star .ss-surgical .ss-motor-params .ss-param .p-grey {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 18.4px !important;
  line-height: 1;
  color: #636363;
  margin-top: 16.7px;
  white-space: nowrap;
}
.surgic-star .ss-surgical .ss-speed-bar {
  position: relative;
  width: 892.2px;
  margin: 31.1px auto 0 auto;
  left: 7.6px;
}
.surgic-star .ss-surgical .ss-speed-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: baseline;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 21.9px;
  color: #1a1a1a;
  line-height: 1;
}
.surgic-star .ss-surgical .ss-speed-row .ss-speed-value {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 41.3px;
  color: #ff7033;
  margin: 0;
  letter-spacing: 0;
  line-height: 1;
  position: relative;
  top: 9.3px;
}
.surgic-star .ss-surgical .ss-slider {
  position: relative;
  height: 16.9px;
  margin: 28.7px 0 0 0;
}
.surgic-star .ss-surgical .ss-slider .ss-slider-track {
  position: absolute;
  inset: 0;
  background: #cccccc;
  border-radius: 8.5px;
}
.surgic-star .ss-surgical .ss-slider .ss-slider-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 16.9px;
  background: linear-gradient(to right, #67d2e2, #2494ff);
  border-radius: 8.5px;
}
.surgic-star .ss-surgical .ss-speed-row > span:nth-child(1) {
  justify-self: start;
  padding-left: 3px;
}
.surgic-star .ss-surgical .ss-speed-row > span:nth-child(3) {
  justify-self: end;
  padding-right: 4px;
}
.surgic-star .ss-surgical .ss-speed-hint {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14.2px;
}
.surgic-star .ss-surgical .ss-speed-hint .ss-hint-plus {
  font-family: 'MiSans-Normal', sans-serif;
  font-size: 74px;
  line-height: 1;
  color: #1a1a1a;
  position: relative;
  top: -4.2px;
  margin: 0 0 0 -2.5px;
}
.surgic-star .ss-surgical .ss-speed-hint span {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 20.85px;
  line-height: 1;
  color: #000;
  white-space: nowrap;
}
.surgic-star .ss-surgical .ss-speed-hint .ss-hint-minus {
  font-family: 'MiSans-Normal', sans-serif;
  display: block;
  width: 27.9px;
  height: 5.9px;
  margin-right: 8.5px;
  position: relative;
  top: -5.1px;
  background: #1a1a1a;
}
</style>
